import React from 'react';
import './AddressCard.scss';
import { AddressIcon, PlusIconCircle, TelephoneIcon } from '../../../../assets/images';
import { Link } from 'react-router-dom';
import { BusinessAddressListType } from '../../../../redux/clientSettings/clientSettingTypes';


type AppProps = {
  isAddNewAddress?: boolean;
  client_code?: number;
  company_name?: string;
  data?: BusinessAddressListType;
  history?: any;
  isAddressEditPresent?:boolean
}

const AddressCard = ({
  isAddNewAddress,
  client_code,
  company_name,
  data,
  history,
  isAddressEditPresent
}: AppProps) => {



  const finalLink = {
    pathname: `/client-settings/addresses/add/${client_code}`,
    state: { client_code, company_name }
  }

  const editAddressLink = {
    pathname: `/client-settings/addresses/edit/${client_code}`,
    state: { client_code, company_name, data }
  }

  const AddNewAddressTile = () => {
    return <Link to={finalLink} style={{ textDecoration: 'none' }}>
      <div className="d-flex flex-column align-items-center pointer">
        <img src={PlusIconCircle} alt="Add Business Address" width='30px' height='30px' />
        <p className='mt-2 mb-0' style={{ color: '#dd4433', fontSize: '14px', fontWeight: 400 }}>Add New Address</p>
        <p className="mt-0 due-date-text text-center">Click here to add new address for your business</p>
      </div>
    </Link>
  };

  const AddressTile = () => {
    const {address1}:any=data
    let finalAddress=address1?.length>51?`${address1?.slice(0,50)}.....`:address1
    let completeAddress = `${finalAddress}, ${data?.city || ""}${data?.pincode ? ',' : ""} ${data?.pincode || ''}, ${data?.state}${data?.country ? "," : ""} ${data?.country || ""}`;
    return (
      <div className='d-flex flex-column'>
        <div className='trade-name'>
          <h6>{data?.trade_name}</h6>
          <p className='due-date-text' style={{marginBottom:'5px'}}>({data?.ledger_number})</p>
          {!!data?.is_default_address && <div className='default'>Default</div>}
          <div  className='horizontal-line'></div>
          {data?.address1 && <div>
            <span><img src={AddressIcon} className="las la-map-marked-alt address-icon-style" alt='address'></img></span>
            <p className='address-box'>{completeAddress}</p>
          </div>}
          {(data?.telephone || data?.mobile) && <div style={{marginTop:'-12px'}}>
            <span><img src={TelephoneIcon} className="las la-phone address-icon-style" alt='phone'></img></span>
            <p className='telephone-box'>{data?.telephone} {(data?.telephone && data?.mobile) ? " | " : ""} {data?.mobile}</p>
          </div>}
        </div>
      </div>
    )
  }
  
  return (
    <div className={`address-card-box ${isAddNewAddress ? 'justify-content-center' : ''}`}>
      {!isAddNewAddress && isAddressEditPresent && <Link to={editAddressLink}><div className="edit-address-icon">
        <i className="las la-pen"></i>
      </div></Link>}
      {isAddNewAddress ? AddNewAddressTile() : AddressTile()}
    </div>
  )
};

export default AddressCard;